


















// Importing components
import BaseNavigation from '@/base/BaseNavigation.vue';
import BaseFooter from '@/base/BaseFooter.vue';
import BaseSideBar from '@/base/BaseSideBar.vue';

export default {
    name: 'LayoutApp',
    components: {
        BaseNavigation,
        BaseFooter,
        BaseSideBar,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
    },
};
